module.exports = __webpack_public_path__ + "img/west-vvip-gal-11.ef1826a2.jpg";